import React from 'react';
import routes from '../constants/routes.json';
import { Link } from 'react-router-dom';

import { Typography, Space } from 'antd';

import 'antd/dist/antd.css';

import styles from './Privacy.css';

const { Title } = Typography;

export default function Privacy(): JSX.Element {
  return (
    <div className={styles.container} data-tid="container">
      <Title>Privacy Notice</Title>
      <Title level={5}>Last updated October 24, 2020</Title>
      <Space direction="vertical">
        <div>
          Thank you for choosing to be part of our community at My BTC Stats
          ("Company", "we", "us", "our"). We are committed to protecting your
          personal information and your right to privacy. If you have any
          questions or concerns about this privacy notice, or our practices with
          regards to your personal information, please contact us at
          hello@bryanmillstein.com.
        </div>
        <div>
          When you visit our website http://www.mybtcstats.com (the "Website"),
          and more generally, use any of our services (the "Services", which
          include the Website), we appreciate that you are trusting us with your
          personal information. We take your privacy very seriously. In this
          privacy notice, we seek to explain to you in the clearest way possible
          what information we collect, how we use it and what rights you have in
          relation to it. We hope you take some time to read through it
          carefully, as it is important. If there are any terms in this privacy
          notice that you do not agree with, please discontinue use of our
          Services immediately.
        </div>
        <div>
          This privacy notice applies to all information collected through our
          Services (which, as described above, includes our Website), as well
          as, any related services, sales, marketing or events.
        </div>
        <div>
          Please read this privacy notice carefully as it will help you
          understand what we do with the information that we collect.
        </div>
        <div>
          <Title level={5}>1. WHAT INFORMATION DO WE COLLECT?</Title>
          We do not collect any information.
        </div>
        <div>
          <Title level={5}>
            2. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
          </Title>
          In Short: We only share information with your consent, to comply with
          laws, to provide you with services, to protect your rights, or to
          fulfill business obligations. We may process or share your data that
          we hold based on the following legal basis: Consent: We may process
          your data if you have given us specific consent to use your personal
          information for a specific purpose. Legitimate Interests: We may
          process your data when it is reasonably necessary to achieve our
          legitimate business interests. Performance of a Contract: Where we
          have entered into a contract with you, we may process your personal
          information to fulfill the terms of our contract. Legal Obligations:
          We may disclose your information where we are legally required to do
          so in order to comply with applicable law, governmental requests, a
          judicial proceeding, court order, or legal process, such as in
          response to a court order or a subpoena (including in response to
          public authorities to meet national security or law enforcement
          requirements). Vital Interests: We may disclose your information where
          we believe it is necessary to investigate, prevent, or take action
          regarding potential violations of our policies, suspected fraud,
          situations involving potential threats to the safety of any person and
          illegal activities, or as evidence in litigation in which we are
          involved. More specifically, we may need to process your data or share
          your personal information in the following situations: Business
          Transfers. We may share or transfer your information in connection
          with, or during negotiations of, any merger, sale of company assets,
          financing, or acquisition of all or a portion of our business to
          another company.
        </div>
        <div>
          <Title level={5}>
            3. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
          </Title>
          In Short: We may transfer, store, and process your information in
          countries other than your own. Our servers are located in. If you are
          accessing our Website from outside, please be aware that your
          information may be transferred to, stored, and processed by us in our
          facilities and by those third parties with whom we may share your
          personal information (see "WILL YOUR INFORMATION BE SHARED WITH
          ANYONE?" above), in and other countries. If you are a resident in the
          European Economic Area, then these countries may not necessarily have
          data protection laws or other similar laws as comprehensive as those
          in your country. We will however take all necessary measures to
          protect your personal information in accordance with this privacy
          notice and applicable law.
        </div>
        <div>
          <Title level={5}>4. HOW LONG DO WE KEEP YOUR INFORMATION?</Title>
          In Short: We do not keep your information.
        </div>
        <div>
          <Title level={5}>5. HOW DO WE KEEP YOUR INFORMATION SAFE?</Title>
          In Short: We aim to protect your personal information through a system
          of organizational and technical security measures. We have implemented
          appropriate technical and organizational security measures designed to
          protect the security of any personal information we process. However,
          despite our safeguards and efforts to secure your information, no
          electronic transmission over the Internet or information storage
          technology can be guaranteed to be 100% secure, so we cannot promise
          or guarantee that hackers, cybercriminals, or other unauthorized third
          parties will not be able to defeat our security, and improperly
          collect, access, steal, or modify your information. Although we will
          do our best to protect your personal information, transmission of
          personal information to and from our Website is at your own risk. You
          should only access the Website within a secure environment.
        </div>
        <div>
          <Title level={5}>6. WHAT ARE YOUR PRIVACY RIGHTS?</Title>
          In Short: You may review, change, or terminate your account at any
          time. If you are a resident in the European Economic Area and you
          believe we are unlawfully processing your personal information, you
          also have the right to complain to your local data protection
          supervisory authority. You can find their contact details here:
          http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
          If you are a resident in Switzerland, the contact details for the data
          protection authorities are available here:
          https://www.edoeb.admin.ch/edoeb/en/home.html.
        </div>
        <div>
          <Title level={5}>7. CONTROLS FOR DO-NOT-TRACK FEATURES</Title>
          Most web browsers and some mobile operating systems and mobile
          applications include a Do-Not-Track ("DNT") feature or setting you can
          activate to signal your privacy preference not to have data about your
          online browsing activities monitored and collected. At this stage no
          uniform technology standard for recognizing and implementing DNT
          signals has been finalized. As such, we do not currently respond to
          DNT browser signals or any other mechanism that automatically
          communicates your choice not to be tracked online. If a standard for
          online tracking is adopted that we must follow in the future, we will
          inform you about that practice in a revised version of this privacy
          notice.
        </div>
        <div>
          <Title level={5}>
            8. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
          </Title>
          In Short: Yes, if you are a resident of California, you are granted
          specific rights regarding access to your personal information.
          California Civil Code Section 1798.83, also known as the "Shine The
          Light" law, permits our users who are California residents to request
          and obtain from us, once a year and free of charge, information about
          categories of personal information (if any) we disclosed to third
          parties for direct marketing purposes and the names and addresses of
          all third parties with which we shared personal information in the
          immediately preceding calendar year. If you are a California resident
          and would like to make such a request, please submit your request in
          writing to us using the contact information provided below. If you are
          under 18 years of age, reside in California, and have a registered
          account with the Website, you have the right to request removal of
          unwanted data that you publicly post on the Website. To request
          removal of such data, please contact us using the contact information
          provided below, and include the email address associated with your
          account and a statement that you reside in California. We will make
          sure the data is not publicly displayed on the Website, but please be
          aware that the data may not be completely or comprehensively removed
          from all our systems (e.g. backups, etc.).
        </div>
        <div>
          <Title level={5}>9. DO WE MAKE UPDATES TO THIS NOTICE?</Title>
          In Short: Yes, we will update this notice as necessary to stay
          compliant with relevant laws. We may update this privacy notice from
          time to time. The updated version will be indicated by an updated
          "Revised" date and the updated version will be effective as soon as it
          is accessible. If we make material changes to this privacy notice, we
          may notify you either by prominently posting a notice of such changes
          or by directly sending you a notification. We encourage you to review
          this privacy notice frequently to be informed of how we are protecting
          your information.
        </div>
        <div>
          <Title level={5}>10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</Title>
          If you have questions or comments about this notice, you may email us
          at hello@bryanmillstein.com
        </div>
      </Space>
    </div>
  );
}
